import { useTranslation } from "react-i18next";
import IndieStaticSelect from "./IndieStaticSelect";

export const IndieFiscalSpacesSelect = ({ ...params }) => {
    const { t } = useTranslation();

    const data = [
        { value: 1, label: "Nacional" },
        { value: 2, label: "Externo" },
        { value: 3, label: "Intra-Comunitário" },
    ];
    
    return (
        <IndieStaticSelect
            {...params}
            label={t("label.form.fiscalSpace")}
            options={data}
            sx={{ width:300 }}
        />
    );
};
